<template>
	<div class="page_content module_page explore_entity_inside insights" v-if="permission && permission.version === '5'" aria-label="explore program guide results">

		<div class="row page-heading">
      		<div class="col-xl-8 col-lg-8 col-md-8 col-sm-11 col-xs-11 input module_heading" role="heading" aria-level="1">
        		<span class="module_icon ico-insight"></span>
        		<div class="head_txt module_type_name institution-title ace_sec_hd">Exploring Insights</div>
      		</div>

      		<div class="col-xl-4 col-lg-4 col-md-4 col-sm-1 col-xs-1 btn_container">
      			<!--
         		<b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
          			<template slot="button-content">
            			<span class="icon-menu3x3"></span>
          			</template>
        		</b-dropdown>
        		<b-btn class="btn btn-primary">Request Info</b-btn>
        		<b-btn class="btn btn-primary">Apply Now</b-btn>
        		-->
      		</div>
    	</div>

		<div class="page_content_container">
			<explore-insight-list :type="'insights'"></explore-insight-list>
		</div> <!-- .page_content_container -->

	</div>
</template>

<script>
import '../../../assets/module/sass/explore/explore.scss'
import '../../../assets/module/css/user/userList.min.css'
import '../../../assets/module/css/institution/institutionEntities.min.css'
import ExploreInsightList from './ExploreInsightList'
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'explore-insights-results',
  components: {
    ExploreInsightList
  },
  data () {
    return {
    }
  },

  mounted () {
    this.loadExploreInsights()
  },

  methods: {
    ...mapActions([
      'setCurrentFacet'
    ]),
    loadExploreInsights () {
      this.setCurrentFacet('insights')
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'packages': state => state.institution.packages
    }),
    isClearlyNextPackageEnabled () {
      let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
      if (clearlyNextFeature && clearlyNextFeature.enabled) {
        return true
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsightsResults.vue